import { useCatalogExchange } from 'hooks/useCatalogExchange';
import { useMemo } from 'react';
import { ICountryExchangeDetail } from 'types/countries';
import UploadForm from 'views/bulkUpload/components/UploadForm/UploadForm';
import {
  UploadFormOption,
  UploadFormOptionCheckbox,
  UploadFormOptionDropdown
} from 'views/bulkUpload/components/UploadForm/UploadForm.types';
import {
  IUploadInfo,
  uploadTemplateInfo,
  uploadTemplateInfoWithErrors
} from 'views/bulkUpload/UploadCatalog/content/uploadCatalogInfo';
import { renderCheckboxOptions, renderDropdownOptionsUpload } from '../../utils/renderOptions';
import './DownloadCatalogStep1.scss';

interface DownloadCatalogStep1Props {
  selectedCountry: ICountryExchangeDetail | undefined;
  handleSelectedCountry: (country: ICountryExchangeDetail) => void;
  replaceCatalog: boolean;
  handleReplaceCatalog: (value: boolean) => void;
  disableReplaceCatalog: boolean;
  hasErrors: boolean;
  errorTemplateURL?: string;
  handleSubmitUploadForm: (file: File) => Promise<void>;
}

const DownloadCatalogStep1 = ({
  selectedCountry,
  handleSelectedCountry,
  replaceCatalog,
  handleReplaceCatalog,
  disableReplaceCatalog,
  hasErrors,
  errorTemplateURL,
  handleSubmitUploadForm
}: DownloadCatalogStep1Props) => {
  const { countries } = useCatalogExchange();

  const dropdownOptionsUpload = useMemo<UploadFormOptionDropdown[]>(
    () => renderDropdownOptionsUpload(countries, selectedCountry, handleSelectedCountry),
    [countries, selectedCountry]
  );

  const checkboxOptions = useMemo<UploadFormOptionCheckbox[]>(
    () => renderCheckboxOptions(replaceCatalog, handleReplaceCatalog, disableReplaceCatalog),
    [replaceCatalog, disableReplaceCatalog]
  );

  const UploadFormOptions = useMemo<UploadFormOption[]>(
    () => [...dropdownOptionsUpload, ...checkboxOptions],
    [dropdownOptionsUpload, checkboxOptions]
  );

  const uploadInfoUploadTemplate = useMemo<IUploadInfo>(() => {
    if (hasErrors) {
      return uploadTemplateInfoWithErrors(errorTemplateURL || '');
    }
    return uploadTemplateInfo;
  }, [hasErrors, errorTemplateURL]);

  return (
    <UploadForm
      options={UploadFormOptions}
      onSubmit={handleSubmitUploadForm}
      backLink="/bulk-upload/type-of-charge"
      confirmationModal={replaceCatalog}
      fileInputIsDisabled={!selectedCountry}
      uploadInfo={uploadInfoUploadTemplate}
      customClassName="downloadUploadCatalogFormStep1"
    />
  );
};

export default DownloadCatalogStep1;
